<template>
  <div class="text-lg">
    <p v-if="message" v-html="message"></p>
    <div v-else>
      <p>
        We are excited to be part of The Side-Out Foundation and its Dig Pink initiative, and we need your help to make our campaign successful!
      </p>
      <p>
        Funds raised for Side-Out go toward a clinical trial specifically for patients with stage 4 breast cancer, the most advanced form of the disease and the least funded area of research.
      </p>
      <p>
        Thank you so much for helping us to make an impact!
      </p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'CampaignPageMessage',

    props: {
      message: {
        type: String,
        required: false,
        default: '',
      },
    },

    watch: {
      message: {
        immediate: true,
        handler(newValue, oldValue) {
          this.$nextTick(() => {
            this.removeFromInlineStyle(this.$el);
          });
        },
      },
    },

    methods: {
      removeFromInlineStyle(el) {
        el.querySelectorAll('a').forEach((a) => {
          a.removeAttribute("style");
        });
      },
    },
  }
</script>

<style scoped>
</style>